
export default {
    data() {
        return {
            formLoading: false,
            routeName: '',
            // addUrl: '',
            provinceArr: [],//省份
            cityArr: [],
            districtArr: [],
            prov: "",
            city: "",
            district:'',
        };
    },
    mounted() {
        if (this.$route.name=='Register') {
            this.provinceArr=[]
            this.getprovinceList()
        }
    },
    activated() {
        this.routeName = this.$route.name;
        if (this.routeName == 'BusinessManagementAdd'||this.routeName=='Register') {
            this.provinceArr=[]
            this.getprovinceList()
        }
        this.$refs[this.formData].resetFields();
    },
    watch: {
        navList(value) {
            const res = value.some(item => item.name == this.routeName);
            if (!res) {
                this.$destroy();
            }
        },
        prov() {
            this.cityArr=[]
            this.getcityList();
        },
        city() {
            this.districtArr=[]
            this.getdistricList();
        },
    },
    computed: {
        navList() {
            return this.$store.state.app.tagNavList;
        }
    },
    methods: {
        // save(name) {
        //     // if (this.routeName == 'BusinessManagementAdd') {
        //     //     this.formData.provinceId=this.prov
        //     //     this.formData.cityId=this.city
        //     //     this.formData.districtId=this.district
        //     // }
        //     // this.formLoading = true;
        //     this.$refs[name].validate((valid) => {
        //         if (valid) {
        //             this.$axios.post(this.addUrl, this.formData).then(res => {
        //                 this.formLoading = false;
        //                 if (res.code == 1) {
        //                     this.$router.go(-1)
        //                 } else {
        //                     this.$Message.error(res.msg);
        //                 }
        //             });
        //         } else {
        //             this.$Message.error('请先完善信息');
        //             this.formLoading = false;
        //         }
        //     })
        // },
        getprovinceList() {//获取省
            this.$axios.get("/app/region/getProvince").then(res => {
                if (res.code == 1) {
                    if (res.data) {
                        this.provinceArr = res.data
                    } else {
                        this.$Message.error('暂无数据')
                    }
                } else {
                    this.$Message.error(res.msg);
                }
            });
        },
        getcityList(){//获取市
            this.$axios.get("/app/region/getCity",{province_id:this.prov}).then(res => {
              if (res.code == 1) {
                this.cityArr=res.data
                 if(this.cityArr.length>0){
                  this.formData.provinceId=this.prov.toString()
                }
              } else {
                this.$Message.error(res.msg);
              }
            });
          },
          getdistricList(){//获取区
            this.$axios.get("/app/region/getArea",{city_id:this.city}).then(res => {
              if (res.code == 1) {
                this.districtArr=res.data
                  this.formData.cityId=this.city.toString()
              } else {
                this.$Message.error(res.msg);
              }
            });
          }
    }
};